import DashboardCard from "../components/DashboardCard";
import CountdownCard from "../components/CountdownCard";
import { useDashboard } from "../context/DashboardContext";

const FIREBASE_CONSOLE_URL = "https://console.firebase.google.com/u/0/project/madetest-81fde/overview";

function formatValue(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;
  return value;
}

function formatDate(value) {
  if (!value) return "—";

  const date = value.toDate ? value.toDate() : new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleString("es-CO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

function getSeasonEndDate(gameConfig) {
  return (
    gameConfig?.currentSeasonEndAt ||
    gameConfig?.seasonEndDate ||
    gameConfig?.currentSeasonEndDate ||
    null
  );
}

function AdminDashboard() {
  const {
    dashboardData,
    loadingDashboard,
    dashboardError,
    refreshDashboard,
  } = useDashboard();

  const metrics = dashboardData?.metrics || {};
  const gameConfig = dashboardData?.gameConfig || {};

  const dailyMissionIds = Array.isArray(gameConfig.dailyMissionIds)
    ? gameConfig.dailyMissionIds
    : [];

  const seasonEndDate = getSeasonEndDate(gameConfig);

  if (loadingDashboard) {
    return (
      <main className="loading-page">
        <section className="loading-card">
          <div className="banter-loader" aria-hidden="true">
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
            <div className="banter-loader__box"></div>
          </div>

          <h2>Cargando dashboard...</h2>
          <p>Consultando usuarios, minijuegos, tienda, misiones y temporada.</p>
        </section>
      </main>
    );
  }

  return (
    <section className="dashboard-page">
      <div className="dashboard-hero">
        <div>
          <span className="section-eyebrow">Panel general</span>
          <h2>Resumen general</h2>
          <p>
            Vista rápida del estado del juego, contenido principal y accesos de
            administración.
          </p>
        </div>

        <button className="secondary-button" onClick={refreshDashboard}>
          🔄 Actualizar
        </button>
      </div>

      {dashboardError && <p className="dashboard-error">{dashboardError}</p>}

      <div className="dashboard-grid dashboard-grid--main">
        <DashboardCard
          title="Usuarios totales"
          value={formatValue(metrics.totalUsers, 0)}
          subtitle={`${formatValue(metrics.totalAdmins, 0)} administradores`}
          icon="👥"
          variant="blue"
        />

        <DashboardCard
          title="Minijuegos activos"
          value={formatValue(metrics.activeMinigames, 0)}
          subtitle={`Totales: ${formatValue(metrics.totalMinigames, 0)}`}
          icon="🎮"
          variant="green"
        />

        <DashboardCard
          title="Misiones diarias"
          value={dailyMissionIds.length}
          subtitle={formatValue(
            gameConfig.dailyPeriodId,
            "dailyPeriodId no configurado"
          )}
          icon="🎯"
          variant="dark"
        />

        <DashboardCard
          title="Temporada actual"
          value={formatValue(gameConfig.currentSeason)}
          subtitle="config/game.currentSeason"
          icon="🏆"
          variant="purple"
        />

        {/*
        <DashboardCard
          title="Mantenimiento"
          value={gameConfig.maintenanceMode ? "Activo" : "Inactivo"}
          subtitle="Estado general del juego"
          icon={gameConfig.maintenanceMode ? "🚧" : "✅"}
          variant={gameConfig.maintenanceMode ? "dark" : "green"}
        />
        */}

        {/*
        <DashboardCard
          title="Objetos tienda"
          value={formatValue(metrics.totalStoreItems, "—")}
          subtitle={`${formatValue(metrics.activeStoreItems, "—")} activos`}
          icon="🛒"
          variant="blue"
        />
        */}

        {/*
        <DashboardCard
          title="Misiones totales"
          value={formatValue(metrics.totalMissions, "—")}
          subtitle={`${formatValue(metrics.activeMissions, "—")} activas`}
          icon="📋"
          variant="green"
        />
        */}

        {/*
        <DashboardCard
          title="Versión del juego"
          value={formatValue(gameConfig.gameVersion)}
          subtitle="gameVersion"
          icon="⚙️"
          variant="purple"
        />
        */}
      </div>

      {/*
      <div className="dashboard-overview-grid">
        <section className="dashboard-panel">
          <div className="dashboard-panel__header">
            <div>
              <span className="section-eyebrow">Daily</span>
              <h3>Misiones activas hoy</h3>
            </div>

            <span className="section-count">{dailyMissionIds.length}</span>
          </div>

          <div className="dashboard-info-row">
            <span>Periodo diario</span>
            <strong>{formatValue(gameConfig.dailyPeriodId)}</strong>
          </div>

          <div className="dashboard-info-row">
            <span>Actualizado</span>
            <strong>{formatDate(gameConfig.dailyMissionsUpdatedAt)}</strong>
          </div>

          {dailyMissionIds.length === 0 ? (
            <p className="empty-state">No hay misiones diarias activas.</p>
          ) : (
            <div className="dashboard-daily-list">
              {dailyMissionIds.map((missionId) => (
                <article key={missionId} className="dashboard-daily-item">
                  <span>🎯</span>

                  <div>
                    <strong>{missionId}</strong>
                    <small>Incluida en dailyMissionIds</small>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>

        <section className="dashboard-panel dashboard-season-panel">
          <div className="dashboard-panel__header">
            <div>
              <span className="section-eyebrow">Temporada</span>
              <h3>Temporizador</h3>
            </div>

            <span className="section-count">
              Temporada {formatValue(gameConfig.currentSeason)}
            </span>
          </div>

          {seasonEndDate ? (
            <CountdownCard
              title={`Temporada ${formatValue(gameConfig.currentSeason)}`}
              subtitle="Termina en"
              targetDate={seasonEndDate}
            />
          ) : (
            <div className="dashboard-empty-card">
              <span>⏳</span>
              <strong>Fin de temporada no configurado</strong>
              <p>Configura currentSeasonEndAt en config/game.</p>
            </div>
          )}
        </section>
      </div>

      <div className="dashboard-overview-grid dashboard-overview-grid--single">

        <section className="dashboard-panel">
          <div className="dashboard-panel__header">
            <div>
              <span className="section-eyebrow">Configuración</span>
              <h3>Estado del juego</h3>
            </div>
          </div>

          <div className="dashboard-config-list">
            <div>
              <span>Temporada actual</span>
              <strong>{formatValue(gameConfig.currentSeason)}</strong>
            </div>

            <div>
              <span>Versión del juego</span>
              <strong>{formatValue(gameConfig.gameVersion)}</strong>
            </div>

            <div>
              <span>Mantenimiento</span>
              <strong
                className={
                  gameConfig.maintenanceMode
                    ? "dashboard-status dashboard-status--danger"
                    : "dashboard-status dashboard-status--success"
                }
              >
                {gameConfig.maintenanceMode ? "Activo" : "Inactivo"}
              </strong>
            </div>
          </div>
        </section>


        <section className="dashboard-panel">
          <div className="dashboard-panel__header">
            <div>
              <span className="section-eyebrow">Contenido</span>
              <h3>Resumen rápido</h3>
            </div>
          </div>

          <div className="dashboard-mini-stats">
            <article>
              <span>👥</span>
              <div>
                <strong>{formatValue(metrics.totalUsers, 0)}</strong>
                <small>Usuarios</small>
              </div>
            </article>

            <article>
              <span>🛡️</span>
              <div>
                <strong>{formatValue(metrics.totalAdmins, 0)}</strong>
                <small>Admins</small>
              </div>
            </article>

            <article>
              <span>🎮</span>
              <div>
                <strong>{formatValue(metrics.totalMinigames, 0)}</strong>
                <small>Minijuegos</small>
              </div>
            </article>

            <article>
              <span>🛒</span>
              <div>
                <strong>{formatValue(metrics.totalStoreItems, "—")}</strong>
                <small>Tienda</small>
              </div>
            </article>
          </div>
        </section>
      </div>
      */}

      <section className="dashboard-panel firebase-console-panel">
        <div className="firebase-console-card">
          <div className="firebase-console-card__icon">🔥</div>

          <div className="firebase-console-card__content">
            <span className="section-eyebrow">Firebase</span>
            <h3>Dashboard oficial de Firebase</h3>
            <p>
              Abre Firebase Console para revisar métricas oficiales, uso de
              Firestore, Storage, Authentication, reglas, billing y demás
              configuración del proyecto.
            </p>
          </div>

          <a
            className="primary-action-button firebase-console-link"
            href={FIREBASE_CONSOLE_URL}
            target="_blank"
            rel="noreferrer"
          >
            Abrir Firebase Console ↗
          </a>
        </div>
      </section>
    </section>
  );
}

export default AdminDashboard;